import axios from "axios"
export function searchScreenData(token, keyword) {
    return axios.get(process.env.REACT_APP_API_URL + `/searchScreenData?keyword=${keyword}`, {
        headers: {
            'Authorization': `${token}`
        }
    });
}